import { config } from "../config";
import { newLogo } from "../assets/images";

// Function will get called when clicked on the pay button.
export async function displayRazorpayPaymentSdk({
    id,
    amount,
    apiKeyId,
    currency,
    description,
    email,
    name,
    mobile,
    transactionId,
    razorpayAmount,
    setShowLoader,
    onPaymentSuccess,
}) {
    const res = await loadRazorpayScript(
        "https://checkout.razorpay.com/v1/checkout.js",
    );

    if (!res) {
        if (setShowLoader) setShowLoader(false);
        alert("Razorpay SDK failed to load. Please check your internet connection.");
        return;
    }
    if (setShowLoader) setShowLoader(false);

    const options = {
        key: apiKeyId || config?.razorAppKey || "",
        amount: razorpayAmount || amount * 100,
        currency: currency || "INR",
        name: "Club Mango",
        description: description || "Event Booking",
        image: newLogo,
        order_id: transactionId,
        prefill: {
            name: name,
            email: email,
            contact: mobile,
        },
        handler: function (response) {
            if (
                response.razorpay_payment_id &&
                response.razorpay_order_id &&
                response.razorpay_signature
            ) {
                onPaymentSuccess({
                    ...response,
                    onlinePaymentId: id,
                });
            } else {
                if (setShowLoader) setShowLoader(false);
            }
        },
        notes: {
            address: "",
        },
        theme: {
            color: "#f5b940",
        },
    };

    const paymentObject = new window.Razorpay(options);
    paymentObject.on("payment.failed", function (response) {
        if (setShowLoader) setShowLoader(false);
    });
    paymentObject.open();
}

// Function to load razorpay script for the display of razorpay payment SDK.
function loadRazorpayScript(src) {
    return new Promise((resolve) => {
        const script = document.createElement("script");
        script.src = src;
        script.onload = () => {
            resolve(true);
        };
        script.onerror = () => {
            resolve(false);
        };
        document.body.appendChild(script);
    });
}
